import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchGesellschaften(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('gesellschaften')
    .select('id, name, logo_url, bereich, updated_at')
    .ilike('name', pattern)
    .limit(serverLimit);

  if (error) {
    console.error('Gesellschaften search error:', error);
    return [];
  }

  return (data || [])
    .filter(g => matchFn(term, g.name, g.bereich))
    .slice(0, limit)
    .map(g => {
      const title = g.name;
      const subtitle = g.bereich || undefined;
      
      return {
        id: g.id,
        type: 'gesellschaften' as SearchSectionId,
        title,
        subtitle,
        badge: 'Gesellschaft',
        data: g,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, g.updated_at)
      };
    });
}
